import { useState, useEffect, Fragment } from 'react'
import {PaymentElement, useCheckout} from '@stripe/react-stripe-js';
import { getUserData } from '../../utils/auth';

function CardForm({ onSubmit, isLoading, error }) {
    const checkout = useCheckout();
    const [email, setEmail] = useState('');
    const [cardError, setCardError] = useState('');
    const [stripeLoading, setStripeLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {
        const userData = getUserData();
        if (userData) {
            setEmail(userData.email);
            checkout.updateEmail(userData.email).then((result) => {
                if (result.error) {
                    setCardError(result.error.message);
                } else {
                    setCardError('')
                }
            });
        }
    }, []);
    
    const handleBlur = () => {
        if (email) {
            checkout.updateEmail(email).then((result) => {
                if (result.error) {
                    setCardError(result.error.message);
                } else {
                    setCardError('')
                }
            });
        }
    }
    try {
        
        const handleSubmit = async (e) => {
            e.preventDefault();
            setSubmitLoading(true);
            try {
                checkout.confirm().then((result) => {
                    onSubmit(result);
                    setSubmitLoading(false);
                })
            } catch (err) {
                setSubmitLoading(false);
                console.error('Payment submission error:', err);
                setCardError('發生意外錯誤。請再試一次。');
            }
        };

        return (
            <>
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-semibold">結帳</h2>
                    <div className="text-2xl font-bold">{checkout.total?.total?.amount}</div>
                </div>
                <div className="max-w-md mx-auto bg-white p-6 rounded-lg" data-name="card-form">
                    <h2 className="text-xl font-semibold mb-4">付款詳情</h2>
                    
                    {(cardError || error) && (
                        <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4" data-name="error-message">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <i className="fas fa-exclamation-circle text-red-500"></i>
                                </div>
                                <div className="ml-3">
                                    <p className="text-sm text-red-700">
                                        {cardError || error}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    
                    <form>
                        {stripeLoading ? (
                        <div className="flex justify-center items-center h-64" data-name="loading">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500"></div>
                        </div>) : (<>
                            <div className="mb-4" data-name="name-input">
                                <label htmlFor="nameOnCard" className="block text-gray-700 text-sm font-medium mb-2">
                                    電郵
                                </label>
                                <input
                                    type="text"
                                    id="email"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="請輸入電郵地址"
                                    required
                                    disabled={isLoading}
                                    onBlur={handleBlur}
                                />
                            </div>
                        </>) }

                        <PaymentElement options={{layout: 'accordion'}} onReady={() => {
                            setStripeLoading(false);
                        }}/>

                        { !stripeLoading && (
                            <button
                                type="button"
                                onClick={handleSubmit}
                                className={`mt-4 w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                                    submitLoading ? 'opacity-70 cursor-not-allowed' : ''
                                }`}
                                disabled={submitLoading}
                                data-name="submit-button"
                            >
                                {submitLoading ? (
                                    <div className="flex items-center justify-center">
                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                        處理中...
                                    </div>
                                ) : (
                                    '立即付款'
                                )}
                            </button>
                        ) }
                        
                        <div className="mt-4 flex items-center justify-center" data-name="secure-badge">
                            <i className="fas fa-lock text-gray-500 mr-1"></i>
                            <span className="text-xs text-gray-500">付款由 Stripe 安全加密處理</span>
                        </div>
                    </form>
                </div>
            </>
        );
    } catch (error) {
        console.error('CardForm component error:', error);
        reportError(error);
        return (
            <div className="bg-red-100 p-4 rounded-md">
                <p>載入付款表單時出錯。請刷新頁面並重試。</p>
            </div>
        );
    }
}

export default CardForm;